module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 106.950b505b.png";